import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/toast/state'
import Toast from 'redux/toast/toast.duck'

export default composeReducers(
  createReducerFunction(Toast, defaultState)
)
